import template from './view-cart-summary.html';
import controller from './view-cart-summary.controller';

let viewCartSummaryComponent = {
    restrict: 'E',
    bindings: {
        cart: '<',
        viewCartModel: '<',
        checkoutLink: '<',
        hasInvalidProducts: '<',
        continueShoppingLink: '<',
        shoppingCartForm: '<'
    },
    template,
    controller
};

export default viewCartSummaryComponent;


// WEBPACK FOOTER //
// ./src/app/components/view-cart/view-cart-summary/view-cart-summary.component.js